import {
  SET_LOYALTY,
  INIT_LOYALTY_DATA,
  CREATE_LOYALTY,
  EDIT_LOYALTY,
  RESET_LOYALTY,
  DEACTIVATE_LOYALTY,
  REACTIVATE_LOYALTY
} from './constants'

export function initLoyaltyData () {
  return { type: INIT_LOYALTY_DATA }
}

export function createLoyalty (data) {
  return { type: CREATE_LOYALTY, payload: data }
}

export function editLoyalty (data) {
  return { type: EDIT_LOYALTY, payload: data }
}

export function resetLoyalty (data) {
  return { type: RESET_LOYALTY, payload: data }
}

export function deactivateLoyalty () {
  return { type: DEACTIVATE_LOYALTY }
}

export function reactivateLoyalty (data) {
  return { type: REACTIVATE_LOYALTY, payload: data }
}

export function setLoyalty (loyalty) {
  return { type: SET_LOYALTY, payload: loyalty }
}



// WEBPACK FOOTER //
// ./app/actions/customers/loyalty/index.js